import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from "@angular/core";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideRouter } from "@angular/router";

import { provideEnvironmentNgxMask } from "ngx-mask";

import { auth0ErrorInterceptor } from "./core/interceptors/auth0-error-interceptor";
import { autosyncInterceptor } from "./core/interceptors/autosync-interceptor";
import { authInterceptor } from "./core/interceptors/auth-interceptor";

import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([auth0ErrorInterceptor, authInterceptor, autosyncInterceptor])),
    provideEnvironmentNgxMask(),
  ],
};
